import { styled } from '@mui/material/styles'
import { CardActions } from '@mui/material'

export const CardActionsWrapper = styled(CardActions)(
  ({ theme }) => `
     background: ${theme.colors.alpha.black[5]};
     padding: ${theme.spacing(3)};
`
)
